import { DatePipe } from '@angular/common';
import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { fadeInAnimation } from 'app/core/route-animation/route.animation';
import { CommonUtilService } from 'app/services/commonUtil.service';
import { SpinnerService } from 'app/services/spinner.service';
import { UserService } from 'app/services/user/user.service';

@Component({
  selector: 'ms-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.css'],
  encapsulation: ViewEncapsulation.None,
  host: {
    "[@fadeInAnimation]": 'true'
  },
  animations: [fadeInAnimation]
})
export class UserListComponent implements OnInit, AfterViewInit {

  @ViewChild('actionCellTpl') actionCellTpl: TemplateRef<any>;
  @ViewChild('registerDateTpl') registerDateTpl: TemplateRef<any>;
  @ViewChild('hdrTplWithStatusSearch') hdrTplWithStatusSearch: TemplateRef<any>;
  @ViewChild('statusCellTpl') statusCellTpl: TemplateRef<any>;

  rows = [];
  columns = [];
  excelRows = [];
  dataRows = [];
  temp = [];

  defaultSort = [
    {
      prop: 'registrationDate',
      dir: 'desc'
    }
  ];

  header: string[] = [];

  constructor(private router: Router,
    private userService: UserService,
    private commonUtilService: CommonUtilService,
    private spinnerService: SpinnerService,
    private datePipe: DatePipe) {

    this.spinnerService.start();
    this.getUserList();

  }

  getUserList() {
    this.userService.getAllClienteList().subscribe(data => {
      this.rows = data;
      this.dataRows = data;
      /* console.log(this.rows); */
      this.spinnerService.stop();
    });
  }

  ngAfterViewInit(): void {
    this.columns = [
      { name: 'Data creazione', cellTemplate: this.registerDateTpl, comparator: this.columnRegisterDateComparator.bind(this), width: 140, resizeable: false },
      { name: 'Name', prop: 'fullName', sortable: true, resizeable: false, width: 150 },
      { name: 'Email', prop: 'email', sortable: true, resizeable: false, width: 200 },
      { name: 'Company Name', prop: 'companyName', sortable: true, resizeable: false },
      { name: 'Status', prop: 'status', sortable: true, resizeable: false, width: 130, headerTemplate: this.hdrTplWithStatusSearch, cellTemplate: this.statusCellTpl },
      { name: 'Azioni', sortable: false, resizeable: false, cellTemplate: this.actionCellTpl, width: 150 }
    ];
  }

  ngOnInit(): void {
    this.commonUtilService.translateLang("HRWE.PAGE_TITLE.USER_LIST");
  }

  goToDetail(clientId) {
    this.router.navigate(['/user/detail/' + clientId]);
  }

  columnRegisterDateComparator(propA, propB, rowA, rowB) {
    if (rowA.registrationDate < rowB.registrationDate) { return -1; }
    if (rowA.registrationDate > rowB.registrationDate) { return 1; }
  }

  exportToExcel(): void {

    this.spinnerService.start();

    this.excelRows = this.exportRows();

    this.commonUtilService.ExportAsExcel('Utenti', this.excelRows, "HR Utenti - HRWE.xlsx");

    this.spinnerService.stop();

  }

  exportToPDF(): void {
    this.spinnerService.start();

    this.excelRows = this.exportRows();

    this.commonUtilService.ExportAsPDF(false, this.header, this.excelRows, "HR Utenti - HRWE.pdf");

  }

  exportRows() {

    this.header = ['Data creazione', 'Name', 'Email', 'Company Name', 'Status'];

    let arr = this.rows.map(rec => {
      return {
        'Data creazione': this.datePipe.transform(rec.registrationDate, 'dd/MM/yyyy'),
        'Name': rec.fullName,
        'Email': rec.email,
        'Company Name': rec.companyName,
        'Status': this.commonUtilService.decodeUserStatus(rec.status),
      }
    });

    return arr;
  }

  previousStatusFilter = '';

  filterRows(event, columnName) {

    var searchVal = event.target.value;

    switch (columnName) {
      case "Status":
        this.previousStatusFilter = searchVal;
        break;
    }

    this.temp = this.dataRows;
    this.rows = this.temp.filter(row => {

      const isPartialStatusMatch = !this.previousStatusFilter || (row.status && row.status === this.previousStatusFilter);

      return isPartialStatusMatch;
    });
  }

  changeStatus(email, status) {
    this.spinnerService.start();

    var statusUpdate = {
      status: status,
      hrUserEmail: email
    }

    this.userService.changeHrweUserStatus(statusUpdate).subscribe(data => {
      this.getUserList();
    });

    
  }

}
